var map = {
	"./white/0.25.svg": 765,
	"./white/0.5.svg": 766,
	"./white/0.75.svg": 767,
	"./white/0.svg": 768,
	"./white/1.svg": 769,
	"./white/10.svg": 770,
	"./white/11.svg": 771,
	"./white/2.svg": 772,
	"./white/3.svg": 773,
	"./white/4.svg": 774,
	"./white/5.svg": 775,
	"./white/6.svg": 776,
	"./white/7.svg": 777,
	"./white/8.svg": 778,
	"./white/9.svg": 779,
	"./yellow/0.25.svg": 780,
	"./yellow/0.5.svg": 781,
	"./yellow/0.75.svg": 782,
	"./yellow/0.svg": 783,
	"./yellow/1.svg": 784,
	"./yellow/10.svg": 785,
	"./yellow/11.svg": 786,
	"./yellow/2.svg": 787,
	"./yellow/3.svg": 788,
	"./yellow/4.svg": 789,
	"./yellow/5.svg": 790,
	"./yellow/6.svg": 791,
	"./yellow/7.svg": 792,
	"./yellow/8.svg": 793,
	"./yellow/9.svg": 794
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 764;